import styled, { css } from 'styled-components'

import { hideScrollbar as hideScrollbarStyled } from '@fourthwall/components'

export const Container = styled.div<{
  maxHeight: number
  isScrolledTop?: boolean
  isScrolledBottom?: boolean
  maskPercentage: number
  hideScrollbar?: boolean
}>`
  width: 100%;
  max-height: ${({ maxHeight }) => maxHeight}px;
  overflow-y: scroll;
  mask-image: linear-gradient(
    180deg,
    transparent 0%,
    black
      ${({ isScrolledTop, isScrolledBottom, maskPercentage }) =>
        `${isScrolledTop ? 0 : maskPercentage}% ${100 - (isScrolledBottom ? 0 : maskPercentage)}%`},
    transparent 100%
  );

  ${({ hideScrollbar }) =>
    hideScrollbar &&
    css`
      ${hideScrollbarStyled};
    `}
`

export const ScrollChecker = styled.div`
  height: 1px;
`
